/* eslint-disable max-len */
import React from "react"
import BaseSvgIcon from "./Base"

export default (props) => {
  return (
    <BaseSvgIcon viewBox="0 0 24 24" {...props}>
      <path
        fill="#3D3D36"
        transform="translate(12.000000, 12.500000) rotate(-270.000000) translate(-12.000000, -12.500000) translate(5.500000, 3.500000)"
        d="M0.1875,-4.28101998e-13 L1.1875,-4.28101998e-13 L1.1875,18 L0.1875,18 L0.1875,-4.28101998e-13 Z M5.8125,9.00863467 L6.8125,9.00863467 L6.8125,18 L5.8125,18 L5.8125,9.00863467 Z M11.4375,3.0656171 L12.4375,3.0656171 L12.4375,18 L11.4375,18 L11.4375,3.0656171 Z"
      />
    </BaseSvgIcon>
  )
}
